import React from 'react';
import { motion } from 'framer-motion';
import { DollarSign, MapPinned, Brain, Zap, TrendingUp, Clock } from 'lucide-react';
import { siteConfig } from '../../config/site';

const benefits = [
  {
    icon: MapPinned,
    title: 'Identificá zonas de distinta productividad',
    desc: 'Visualizá la variabilidad real de tu lote antes de sembrar o fertilizar.',
  },
  {
    icon: DollarSign,
    title: 'Optimizá insumos',
    desc: 'Aplicá la dosis de semillas y fertilizantes según la productividad de cada ambiente.',
  },
  {
    icon: Brain,
    title: 'Mejorá el análisis agronómico',
    desc: 'Tomá decisiones operativas fundadas en datos.',
  },
  {
    icon: Zap,
    title: 'Prescribí más rápido',
    desc: 'Del reporte a la prescripción en minutos.',
  },
  {
    icon: TrendingUp,
    title: 'Aumentá los márgenes de ganancia',
    desc: 'Ahorrá en los ambientes menos productivos e invertí en los de mayor productividad.',
  },
  {
    icon: Clock,
    title: 'Ahorrá tiempo',
    desc: 'Sin GIS externo, planillas ni exportaciones manuales.',
  },
];

export function ValueSection() {
  return (
    <section id={siteConfig.anchors.value} className="bg-brand-navy py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="mx-auto mb-12 max-w-2xl text-center">
          <p className="text-xs font-semibold uppercase tracking-wide text-brand-accent">Beneficios</p>
          <h2 className="mt-2 font-display text-3xl font-bold text-white md:text-4xl">
            Valor operativo desde el primer reporte
          </h2>
        </div>

        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {benefits.map((b, i) => {
            const Icon = b.icon;
            return (
              <motion.div
                key={b.title}
                initial={{ opacity: 0, y: 16 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: i * 0.05 }}
                className="rounded-2xl bg-white p-6 shadow-card"
              >
                <div className="mb-3 flex h-10 w-10 items-center justify-center rounded-xl bg-brand-accent/15">
                  <Icon className="h-5 w-5 text-brand-dark" />
                </div>
                <h3 className="font-display font-bold text-brand-dark">{b.title}</h3>
                <p className="mt-2 text-sm text-brand-earth">{b.desc}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
